import { render, staticRenderFns } from "./OrderRetailVerify.vue?vue&type=template&id=3c992dc8&"
import script from "./OrderRetailVerify.vue?vue&type=script&lang=js&"
export * from "./OrderRetailVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports